import Link from 'components/link'
import { connect } from 'react-redux'
import { openPampersRegistrationModal } from '../modals/actions'

const PampersLink = ({ user, registry, openPampersRegistrationModal }) => (
  <Link
    className="h7 inline-block"
    style={{ lineHeight: '17px' }}
    onClick={() => openPampersRegistrationModal({ user, registry })}
  >
    Join Pampers Club, win FREE diapers
  </Link>
)

const mapStateToProps = (state) => ({
  user: state.user,
  registry: state.registry,
})

export default connect(mapStateToProps, { openPampersRegistrationModal })(
  PampersLink
)
